module.exports = __webpack_public_path__ + "4627751e691a2f63cf9a40ff34562ad4.pdf";